(function () {
  'use strict';

  var trackedProductIds = Object.create(null);

  function readProducts(section) {
    var products = Object.create(null);

    section.querySelectorAll('[data-bloo-viewed-product]').forEach(function (node) {
      var productId = node.dataset.productId;
      var key = node.dataset.key;
      var price = Number(node.dataset.priceCents) / 100;

      if (!key || !productId) return;

      products[key] = {
        Name: node.dataset.name,
        ProductName: node.dataset.name,
        ProductID: productId,
        SKU: node.dataset.sku,
        ImageURL: node.dataset.imageUrl,
        URL: node.dataset.url,
        Brand: node.dataset.brand,
        Price: Number.isFinite(price) ? price : 0,
      };
    });

    return products;
  }

  function activeProductKey(section) {
    var mode = section.dataset.blooViewedProductMode;

    if (mode === 'scalp-wash') return section.dataset.activeProduct;
    if (mode === 'bundle') return section.dataset.activeFormula + '-' + section.dataset.activeStack;
    return 'bar';
  }

  function trackActiveProduct(section) {
    if (section.dataset.blooViewedProductVisible !== 'true') return;

    var products = readProducts(section);
    var product = products[activeProductKey(section)];

    if (!product || trackedProductIds[product.ProductID]) return;

    trackedProductIds[product.ProductID] = true;
    window._learnq = window._learnq || [];
    window._learnq.push(['track', 'Viewed Product', product]);

    section.dataset.blooViewedProductTracked = product.ProductID;
    document.dispatchEvent(new CustomEvent('bloo:viewed-product-tracked', { detail: product }));
  }

  function initializeSection(section) {
    if (section.dataset.blooViewedProductInitialized === 'true') return;
    section.dataset.blooViewedProductInitialized = 'true';

    var selectionObserver = new MutationObserver(function () {
      trackActiveProduct(section);
    });

    selectionObserver.observe(section, {
      attributes: true,
      attributeFilter: ['data-active-product', 'data-active-formula', 'data-active-stack'],
    });

    if (!('IntersectionObserver' in window)) {
      section.dataset.blooViewedProductVisible = 'true';
      trackActiveProduct(section);
      return;
    }

    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.dataset.blooViewedProductVisible = 'true';
          trackActiveProduct(section);
          visibilityObserver.disconnect();
        });
      },
      { rootMargin: '0px 0px -35% 0px', threshold: 0.05 }
    );

    visibilityObserver.observe(section);
  }

  function initialize(root) {
    root.querySelectorAll('[data-bloo-viewed-product-section]').forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
